module.exports = __webpack_public_path__ + "media/home.5b186d23.mp4";